import { virtualTreeDataViewModel } from '../views/virtualTreeDataViewModel';
import { treeNodeDto } from '../dto/treeNodeDto';
import { getStatusTypeFrom } from '../../views/TreeNodeStatus';

const TreeNodeTransformer = (() => {
  const parser = (nodes: treeNodeDto[] | undefined) => {
    let treeNodes: virtualTreeDataViewModel[] = [];
    if (nodes && nodes.length > 0) {
      nodes.forEach(node => {
        treeNodes.push({
          label: node.name,
          value: node.name,
          children: parser(node.child),
          isRunning: node.isRunning,
          icon: node.icon,
          currentCheckedState: getStatusTypeFrom(node.currentCheckedState)
        } as virtualTreeDataViewModel);
      });
      return treeNodes;
    }
    return [] as virtualTreeDataViewModel[];
  };

  return {
    from: (nodes: treeNodeDto[]) => parser(nodes) as virtualTreeDataViewModel[]
  };
})();

export default TreeNodeTransformer;
